import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.string.includes.js";
import { getSettingChatHolidays } from "@faire/help-center-utils/settings/getSettingChatHolidays";
import { getSettingPhoneHolidays } from "@faire/help-center-utils/settings/getSettingPhoneHolidays";
var isSupportServiceInHolidayMode = function isSupportServiceInHolidayMode(service) {
  // holiday dates in timestamp format, such as 1700697600000
  var holidays = service === "phone" ? getSettingPhoneHolidays() : getSettingChatHolidays();
  var currentDate = new Date().toJSON().slice(0, 10);
  var currentDateTimestamp = new Date(currentDate).getTime();
  var isHoliday = holidays.includes(currentDateTimestamp);
  return isHoliday;
};
export var isChatInHolidayMode = function isChatInHolidayMode() {
  return isSupportServiceInHolidayMode("chat");
};
export var isPhoneInHolidayMode = function isPhoneInHolidayMode() {
  return isSupportServiceInHolidayMode("phone");
};